import { render, staticRenderFns } from "./modern-luxurious-4.vue?vue&type=template&id=0ff3eadf"
import script from "./modern-luxurious-4.vue?vue&type=script&lang=js"
export * from "./modern-luxurious-4.vue?vue&type=script&lang=js"
import style0 from "./modern-luxurious-4.vue?vue&type=style&index=0&id=0ff3eadf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports